<template>
    <base-modal :visible="true" title="Create new Flow" @close="$emit('close')">
        <base-backend-errors :data="create.error"/>

        <flow-form
            :init_data="{ name: flow.name }"
            :loading="create.loading"
            @cancel="$emit('close')"
            @submit="submit"/>

    </base-modal>
</template>

<script>
import { mapState } from 'vuex';
import FlowForm from './FlowForm.vue';

export default {
    name: 'FlowUpdateModal',
    components: { FlowForm },
    props: ['space', 'flow'],
    computed: mapState('flows', ['create']),
    methods: {
        submit(data) {
            this.$store.dispatch('flows/update', {
                space_id: this.space.id,
                flow_id: this.flow.id,
                data,
            }).then(() => {
                this.$store.dispatch('flows/list', { space_id: this.space.id });
                this.$emit('close');
            });
        },
    },
};
</script>
